define('post-carousel',['controller'], function(controller) {
	var carousels = [];
	
	function Carousel(element) {
		var leftButton = $('<button>')
			.text('')
			.addClass('post-carousel-left-button')
			.appendTo(element);
		var rightButton = $('<button>')
			.text('')
			.addClass('post-carousel-right-button')
			.appendTo(element);
		var postStrip = element.find('.posts');
		var posts = postStrip.children(); // order remains when posts are moved to end/beginning
		var detailsPane = element.find('.post-carousel-details');
		var visualIndex = 0;
		var logicalIndex = 0;
		var scrollPosition = 0;
		var scrollInterval = 0;
		
		var ELEMENT_WIDTH = 120;
			
		leftButton.click(function() {
			goTo(visualIndex - 1);
		});
		rightButton.click(function() {
			goTo(visualIndex + 1);
		});
		
		posts.find('.post-link').data('no-instant', true);
		posts.find('.active .post-link').data('no-instant', false);
		posts.find('.post-link').click(function(e) {
			// not left mouse button?
			if (e.button != 0)
				return;
			
			var post = $(this).closest('.post');
			// allow normal clicks on active post
			if (post.hasClass('active'))
				return;
			
			e.preventDefault();
			var activePost = $(posts[logicalIndex]);
			goTo(visualIndex + post.index() - activePost.index());
		});

		var swipeStartX = null;
		posts.on('touchstart', function(e) {
			if (e.originalEvent.touches.length == 1) {
				var touch = e.originalEvent.touches[0];
				swipeStartX = touch.clientX;
			}
		});

		posts.on('touchmove', function(e) {
			if (swipeStartX !== null && e.originalEvent.touches.length > 0) {
				var distance = swipeStartX - e.originalEvent.touches[0].clientX;
				if (Math.abs(distance) > 100) {
					var direction = distance > 0 ? 1 : -1;
					goTo(visualIndex + direction);
					swipeStartX = null;
				}
			}
		});

		posts.on('touchend', function(e) {
			if (e.originalEvent.touches.length == 0) {
				swipeStartX = null;
			}
		});
		
		function goTo(index) {
			visualIndex = index;
			logicalIndex = index % posts.length;
			if (logicalIndex < 0)
				logicalIndex += posts.length;
			var elem = posts[logicalIndex];
			
			scrollPosition = ELEMENT_WIDTH * visualIndex;
			postStrip.css({left: -scrollPosition});
			
			if (scrollInterval)
				clearInterval(scrollInterval);
			scrollInterval = setInterval(onScrollTick, 100);
			
			posts.removeClass('active');
			var activePost = $(posts[logicalIndex]);
			activePost.addClass('active');
			detailsPane.find('current').removeClass('current').addClass('last');
			detailsPane.empty().append(activePost.find('.hidden-details').clone());
			posts.find('.post-link').data('no-instant', true);
			posts.find('.active .post-link').data('no-instant', false);
		}
		
		function onScrollTick() {
			// margin-left is indentation of post strip
			var offset = -parseInt(postStrip.css('left'));
			
			// has animation finished?
			if (offset == scrollPosition)
				clearTimeout(scrollInterval);
			
			var firstPost = postStrip.children().first();
			while (firstPost.offset().left - element.offset().left + firstPost.width() < 0) {
				// post is shifted left out of visible range, so move it to the end
				firstPost.appendTo(postStrip);
				postStrip.css('margin-left', parseInt(postStrip.css('margin-left')) + ELEMENT_WIDTH);
				firstPost = postStrip.children().first();
			}
			
			firstPost = postStrip.children().first();
			while (firstPost.offset().left - element.offset().left > 0) {
				// a post is missing at the left, so move the last to the front
				postStrip.children().last().prependTo(postStrip);
				postStrip.css('margin-left', parseInt(postStrip.css('margin-left')) - ELEMENT_WIDTH);
				firstPost = postStrip.children().first();
			}
		}
		
		// move last post to front
		onScrollTick();
		
		this.unload = function() {
			if (scrollInterval)
				clearInterval(scrollInterval);
		};
	}
	
	controller.on(function() {
		carousels.forEach(function(c) {
			c.unload();
		});
		$('.post-carousel').each(function() {
			carousels.push(new Carousel($(this)));
		});
	});
});

